// extracted by mini-css-extract-plugin
export var icon = "EntrySkeleton-module--icon--3fa5d";
export var inner = "EntrySkeleton-module--inner--22a37";